import React from 'react';

const SubscriptionCancel = () => {
    return <div>
        Will be shown for cancel action
    </div>
}

export default SubscriptionCancel;